import { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import './NavMenu.css';

const links = [
  { label: 'Home', to: '/#home' },
  { label: 'Experience', to: '/#experience' },
  { label: 'Projects', to: '/#projects' },
  { label: 'Skills', to: '/#skills' },
];

export default function NavMenu() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('/#home');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`nav${scrolled ? ' scrolled' : ''}`}>
      <div className="nav-inner">
        <div className="nav-logo">cs<span>.dev</span></div>

        <ul className="nav-links">
          {links.map(({ label, to }) => (
            <li key={to}>
              <HashLink
                to={to}
                className={active === to ? 'active' : ''}
                onClick={() => setActive(to)}
              >
                {label}
              </HashLink>
            </li>
          ))}
        </ul>

        <a href="mailto:csandoval.eng@gmail.com">
          <button className="nav-cta">Get in Touch</button>
        </a>
      </div>
    </nav>
  );
}
